import ctaImage from "assets/images/cta.png";
import { ButtonSize } from "utils/types/util.types";
import { useScreenSize } from "utils/hooks/useScreenSize";
import { useTranslation } from "react-i18next";
import TelButton from "components/utils/TelButton";
import EmailButton from "components/utils/EmailButton";

function CTA() {

	const screenSize = useScreenSize();

	const getButtonSize = (): ButtonSize => {
		if (screenSize.width > 1024) return ButtonSize.LARGE;
		if (screenSize.width > 640) return ButtonSize.MEDIUM;
		return ButtonSize.SMALL;
	}

	const { t } = useTranslation();

	return (
		<div className="cta container">
			<div className="flex bg-stone-50 rounded-3xl shadow overflow-hidden w-full">
				<div className="p-10 sm:p-[60px] flex flex-col w-full md:w-3/5 justify-between">
					<div className="flex flex-col gap-4 sm:gap-10">
						<div className="text-gray-900 text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-medium">
							{ t("CTA.title") }
						</div>
						<p className="text-gray-900 text-base sm:test-lg lg:text-xl font-light mb-5">
							{ t("CTA.description") }
						</p>
					</div>
					<div className="flex gap-2 sm:gap-[24px] items-start sm:items-center flex-col sm:flex-row">
						<TelButton buttonSize={ getButtonSize() }>
							{ t("CTA.callButton") }
						</TelButton>
						<span className="text-gray-900 text-xl font-medium hidden sm:block">{ t("CTA.buttonsMiddleText") }</span>
						<EmailButton buttonSize={ getButtonSize() }>
							{ t("CTA.emailButton") }
						</EmailButton>
					</div>
				</div>
				<img src={ ctaImage } alt="cta-image" className="w-2/5 object-cover hidden md:block"/>
			</div>
		</div>
	);
}

export default CTA;